/*
  Fit scale popover — tap to open.

  CSS already opens the panel on :hover and :focus-within, which covers mouse
  and keyboard. This file exists for TOUCH, where :hover either never fires or
  sticks after the tap. It also lets a shopper dismiss the panel, which hover
  alone cannot do.
*/
(function () {
  if (window.__fitFeelTip) return;
  window.__fitFeelTip = true;

  var WRAP = '[data-fit-tip]';
  var TRIGGER = '[data-fit-tip-trigger]';

  // Preview hook for the A/B switch: ?fit_feel=line|scale forces an arm
  // without a running test. The CSS variables are documented in fit-feel.css.
  var arm = new URLSearchParams(location.search).get('fit_feel');
  if (arm === 'f') arm = 'line';
  if (arm === 'line' || arm === 'scale') {
    var root = document.documentElement.style;
    root.setProperty('--fit-feel-line', arm === 'line' ? 'block' : 'none');
    root.setProperty('--fit-feel-scale', arm === 'scale' ? 'block' : 'none');
  }

  function close(wrap) {
    wrap.classList.remove('is-open');
    var t = wrap.querySelector(TRIGGER);
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    document.querySelectorAll(WRAP + '.is-open').forEach(function (w) {
      if (w !== except) close(w);
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest ? e.target.closest(TRIGGER) : null;

    if (trigger) {
      var wrap = trigger.closest(WRAP);
      if (!wrap) return;
      var open = wrap.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      closeAll(wrap);
      // Same shape as the theme's `size_changed` event, so the test can count
      // how many shoppers actually open the scale.
      if (open) window.dispatchEvent(new CustomEvent('fit_feel_opened'));
      return;
    }

    // A click inside the panel shouldn't dismiss it; anywhere else should.
    if (!(e.target.closest && e.target.closest(WRAP))) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector(WRAP + '.is-open');
    if (!open) return;
    close(open);
    var t = open.querySelector(TRIGGER);
    if (t) t.focus();
  });
})();
